class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count; 

    functionMixitup(); 
    
     var endlessScroll = new Ajaxinate({
      method: 'click'
    });
    
    
    functionFacetDetails();
    
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form')); 
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove()); 
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url); 
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


function functionFacetDetails() {
var facetsProductGrid = document.querySelector(".facets");
if (facetsProductGrid != null) {
class Accordion {
  constructor(el) { 
    this.el = el; 
    this.summary = el.querySelector('summary'); 
    this.content = el.querySelector('.facets__display-vertical'); 
    this.animation = null; 
    this.isClosing = false; 
    this.isExpanding = false; 
    this.summary.addEventListener('click', (e) => this.onClick(e));
  } 
  onClick(e) { 
    e.preventDefault(); 
    this.el.style.overflow = 'hidden'; 
    if (this.isClosing || !this.el.open) {
      this.open(); 
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  } 
  shrink() { 
    this.isClosing = true; 
    const startHeight = `${this.el.offsetHeight}px`; 
    const endHeight = `${this.summary.offsetHeight}px`; 
    if (this.animation) { 
      this.animation.cancel();
    } 
    this.animation = this.el.animate({ 
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    }); 
    this.animation.onfinish = () => this.onAnimationFinish(false); 
    this.animation.oncancel = () => this.isClosing = false;
  } 
  open() { 
    this.el.style.height = `${this.el.offsetHeight}px`; 
    this.el.open = true; 
    window.requestAnimationFrame(() => this.expand());
  } 
  expand() { 
    this.isExpanding = true; 
    const startHeight = `${this.el.offsetHeight}px`; 
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`; 
    if (this.animation) { 
      this.animation.cancel();
    } 
    this.animation = this.el.animate({ 
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    }); 
    this.animation.onfinish = () => this.onAnimationFinish(true); 
    this.animation.oncancel = () => this.isExpanding = false;
  } 
  onAnimationFinish(open) { 
    this.el.open = open; 
    this.animation = null; 
    this.isClosing = false;
    this.isExpanding = false; 
    this.el.style.height = this.el.style.overflow = '';
  }
} 
document.querySelectorAll('details.details_facet_accordion').forEach((el) => {
  new Accordion(el);
});
} 
}
functionFacetDetails();

function updateCollectionFilterEmptyState(totalShow) {
  var empty = document.querySelector('.collection-filter-empty');
  if (!empty) return;
  empty.hidden = totalShow !== 0;
}

function collectionFilterClass(input) {
  return (input.value || '').replace(/^\./, '');
}

function productMatchesCollectionFilters(product, shineClasses, holdClasses) {
  var matchesShine = !shineClasses.length || shineClasses.some(function (className) {
    return product.classList.contains(className);
  });
  var matchesHold = !holdClasses.length || holdClasses.some(function (className) {
    return product.classList.contains(className);
  });
  return matchesShine && matchesHold;
}

function updateCollectionFilterAvailability() {
  var products = Array.prototype.slice.call(document.querySelectorAll('#product-grid > li.mix'));
  var inputs = Array.prototype.slice.call(document.querySelectorAll('.oldCustomFilter .filter-items input[type="checkbox"]'));

  function selectedClasses(prefix) {
    return inputs.filter(function (input) {
      return input.checked && collectionFilterClass(input).indexOf(prefix) === 0;
    }).map(collectionFilterClass);
  }

  document.querySelectorAll('[data-filter-toggle]').forEach(function (button) {
    var input = document.getElementById(button.getAttribute('data-filter-toggle'));
    if (!input) return;

    if (input.checked) {
      button.disabled = false;
      return;
    }

    var className = collectionFilterClass(input);
    var shineClasses = selectedClasses('shine-');
    var holdClasses = selectedClasses('hold-');
    if (className.indexOf('shine-') === 0) {
      shineClasses = shineClasses.concat(className);
    } else {
      holdClasses = holdClasses.concat(className);
    }

    var matchCount = products.filter(function (product) {
      return productMatchesCollectionFilters(product, shineClasses, holdClasses);
    }).length;

    button.disabled = matchCount === 0;
  });
}

function syncCollectionFilterBar() {
  document.querySelectorAll('[data-filter-toggle]').forEach(function (button) {
    var input = document.getElementById(button.getAttribute('data-filter-toggle'));
    var isActive = !!(input && input.checked);
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
  updateCollectionFilterAvailability();
}

function functionMixitup() {
  if (document.querySelector('.collection-filter-bar')) return;
  mixitup(document.querySelector('.sort-products')).destroy();
  var containerEl = document.querySelector('.sort-products');
  mixitup(containerEl, {
    multifilter: {
      enable: true
    },
    animation: {
      effects: 'fade translateZ(-100px)'
    }
  });
}

let labelbox = document.querySelectorAll(".filter-items label.checkbox-label");
labelbox.forEach(function(box){
  box.addEventListener('click', () => functionMixitup());
});

(function initCollectionFilterBar() {
  var bar = document.querySelector('.collection-filter-bar');
  var containerEl = document.querySelector('.sort-products');
  if (!bar || !containerEl || typeof mixitup !== 'function') return;

  mixitup(containerEl, {
    multifilter: {
      enable: true
    },
    animation: {
      enable: false
    },
    callbacks: {
      onMixEnd: function (state) {
        updateCollectionFilterEmptyState(state.totalShow);
      }
    }
  });

  bar.querySelectorAll('[data-filter-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;
      var input = document.getElementById(button.getAttribute('data-filter-toggle'));
      if (!input) return;
      input.checked = !input.checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncCollectionFilterBar();
    });
  });

  document.querySelectorAll('.oldCustomFilter .filter-items input[type="checkbox"]').forEach(function (input) {
    input.addEventListener('change', syncCollectionFilterBar);
  });

  syncCollectionFilterBar();
})();